/**
 * Comparator to sort loans based on full cost
 */
function sortLoans(loanOne, loanTwo) {

    let loanOneVal = calculateFullCost(
        calculateCurrentLoanAmount(
            loanOne.amount,
            loanOne.payment,
            loanOne.rate,
            loanOne.start,
        ), 
        loanOne.payment, 
        loanOne.rate
    );

    let loanTwoVal = calculateFullCost(
        calculateCurrentLoanAmount(
            loanTwo.amount,
            loanTwo.payment,
            loanTwo.rate,
            loanTwo.start,
        ), 
        loanTwo.payment, 
        loanTwo.rate
    );

    if (loanOneVal > loanTwoVal) {
        return 1;
    } else if (loanTwoVal > loanOneVal) {
        return -1;
    }

    return 0;
}

/**
 * Calculate the amount left in this loan assuming consistent payments from start date to today
 */
function calculateCurrentLoanAmount(amount, payment, rate, start) {

    let millisSinceStart = (new Date).getTime() - start;
    let monthsElapsed = Math.floor(millisSinceStart / 2592000000); // ms in month

    let periodicRate = ( (rate / 100) / 365 );

    for (var i = 0; i < monthsElapsed; i++) {
        amount = (amount + ( (amount * periodicRate) * 30) ) - payment;
    }
    
    return amount.toFixed(2);
}

/**
 * Given an amount, rate and payment figure out how much this loan will cost with interest.
 */
function calculateFullCost(currentAmount, payment, rate) {
    currentAmount = parseFloat(currentAmount);
    let startingAmount = currentAmount;

    let periodicRate = ( (rate / 100) / 365 );

    let lastAmount = Math.Infinity;
    let totalInterest = 0;
    let numMonths = 0;

    while (currentAmount > 0) {
        let interest = ( (currentAmount * periodicRate) * 30)
        currentAmount = (currentAmount + interest) - payment;
        if (currentAmount > lastAmount) {
            throw "Loan will never be paid off";
        }
        totalInterest += interest;
        numMonths++;
        lastAmount = currentAmount;
    }

    return startingAmount + totalInterest;
}

function calculateFullCostByLoan(loan) {
    return calculateFullCost(
        calculateCurrentLoanAmount(loan.amount),
        loan.payment,
        loan.rate,
    ).toFixed(2);
}

function calculateRealCost(spending, loans) {
    loans = loans.sort(sortLoans)
    let cloneLoan = Object.assign({}, loans[0]);
    let realCost = (calculateFullCost(calculateCurrentLoanAmount(loans[0].amount), loans[0].payment, loans[0].rate) - calculateFullCost(calculateCurrentLoanAmount(cloneLoan.amount) - spending, cloneLoan.payment, cloneLoan.rate));
    return realCost == 0 ? "0" : realCost.toFixed(2);
}

exports.calculateRealCost = calculateRealCost;
exports.calculateCurrentLoanAmount = calculateCurrentLoanAmount;
exports.calculateFullCostByLoan = calculateFullCostByLoan;
exports.calculateFullCost = calculateFullCost;
